/**
 * さまざまなユーザーエージェント情報を取得し、利用しやすい形にパース
 * https://github.com/lancedikson/bowser
 * https://bowser-js.github.io/bowser-online/
 */
import Bowser from 'bowser';
const ua = Bowser.parse(window.navigator.userAgent); // ユーザーエージェント情報を取得

const html = document.getElementsByTagName('html')[0]; // html 要素にユーザーエージェント情報を追加

window.addEventListener('load', () => {
  html.setAttribute('data-ua-browser', ua.browser.name);
  html.setAttribute('data-ua-os', ua.os.name);
  html.setAttribute('data-ua-platform', ua.platform.type);
});